import { StanButton, StanInput } from '@/components';
import { BareSvg } from '@/lib/bareSvg';
import { useFormStoreSync } from '@/hooks/useFormStoreSync';
import { useValidator } from '@/features/product-editor/validations/ValidationProvider';

// Import icons
import IcClose from '@/assets/icons/ic-x-close.svg';
import IcReorder from '@/assets/icons/ic-reorder.svg';

interface OptionInputProps {
    option: { value: string; id?: string };
    optionIndex: number;
    fieldIndex: number;
    handleUpdateOptionValue: (optionIndex: number, value: string) => void;
    handleRemoveOption: (optionIndex: number) => void;
}

export const OptionInput = ({
    option,
    optionIndex,
    fieldIndex,
    handleUpdateOptionValue,
    handleRemoveOption,
}: OptionInputProps) => {
    const { questionSectionValidation } = useValidator();
    const {
        register,
        formState: { errors },
    } = questionSectionValidation;
    return (
        <div className='mt-2 flex flex-row rounded-[7px] bg-[var(--bg-color-neutral-bg-weak)] p-0'>
            <div className='ml-2 flex cursor-grab items-center active:cursor-grabbing'>
                <BareSvg SvgComponent={IcReorder} removeFill />
            </div>
            <StanInput
                value={option.value}
                {...useFormStoreSync(register(`${fieldIndex}.options.${optionIndex}.value`), (value: string) =>
                    handleUpdateOptionValue(optionIndex, value)
                )}
                placeholder={`Option ${optionIndex + 1}`}
                className='mr-3 flex-grow px-0'
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                error={!!(errors[fieldIndex] as any)?.options?.[optionIndex]?.value}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                hintText={(errors[fieldIndex] as any)?.options?.[optionIndex]?.value?.message as string}
            />
            <div className='flex w-auto items-center justify-end p-1 pb-2'>
                <StanButton
                    variant='link'
                    name='remove-option-form-fields'
                    onClick={() => handleRemoveOption(optionIndex)}
                    icon={IcClose}
                />
            </div>
        </div>
    );
};
